import React from "react";

import { IActiveLearningLesson } from "../../../state";
import ActiveLearningGuidelineSidebar from "../../../molecules/teacher/ActiveLearningGuidelineSidebar";

import styles from "./ActiveLearningGuideline.module.scss";

export interface Props {
  materialId: string;
  lesson: IActiveLearningLesson | null;
  prevLessonId: number | null;
  nextLessonId: number | null;
  onChangeLesson: (lessonId: number) => void;
}

const ActiveLearningGuideline: React.FC<Props> = ({
  materialId,
  lesson,
  prevLessonId,
  nextLessonId,
  onChangeLesson,
}) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.guidelineImages}>
        {lesson &&
          lesson.guideline_image_urls?.map((url, i) => (
            <div className={styles.imageContainer} key={i}>
              <img
                className={styles.image}
                src={`https://admin.gear.enageed.net${url}`}
                alt={`guideline-${i}`}
              />
            </div>
          ))}
      </div>
      <ActiveLearningGuidelineSidebar
        materialId={materialId}
        lesson={lesson}
        prevLessonId={prevLessonId}
        nextLessonId={nextLessonId}
        onChangeLesson={onChangeLesson}
      />
    </div>
  );
};

export default ActiveLearningGuideline;
